module.exports = __webpack_public_path__ + "img/ic_24_team_athletik.e699d7e1.svg";